import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Welcome from '@/pages/Welcome'
import Shop from '@/pages/Shop'
import FAQ from '@/pages/FAQs'
import PrivacyPolicy from '@/pages/PrivacyPolicy'
import SingleProduct from '@/pages/SingleProduct'
import Resell from '@/pages/Resell'
import BulkBuy from '@/pages/BulkBuy'
import PageNotFound from '@/pages/404'
import Contact from '@/pages/Contact'
import Imprint from '@/pages/Imprint'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: [
    {
      path: '/',
      name: 'Home',
      component: Home
    },
    {
      path: '/welcome',
      name: 'Welcome',
      component: Welcome
    },
    {
      path: '/shop',
      name: 'Shop',
      component: Shop
    },
    {
      path: '/products/:slug',
      component: SingleProduct
    },
    {
      path: '/faq',
      name: 'FAQ',
      component: FAQ
    },
    {
      path: '/contact',
      name: 'Contact',
      component: Contact
    },
    {
      path: '/privacy-policy',
      name: 'Privacy Policy',
      component: PrivacyPolicy
    },
    {
      path: '/search',
      name: 'Search',
      component: Shop
    },
    {
      path: '/resell',
      name: 'Resell',
      component: Resell
    },
    {
      path: '/bulk',
      name: 'BulkBuy',
      component: BulkBuy
    },
    {
      path: '*',
      name: 'NotFound',
      component: PageNotFound
    },
    {
      path: '/imprint',
      name: 'Imprint',
      component: Imprint
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js